import { Variant } from 'framer-motion';

export const TRANSITION_DURATION = 0.5;
export const STAGGER_DELAY = 0.1;

export const animations = {
	blur_in: {
		hidden: {
			opacity: 0,
			filter: 'blur(10px)',
		},
		visible: {
			opacity: 1,
			filter: 'blur(0)',
		},
	},
} satisfies Record<string, Record<string, Variant>>;
